import React from 'react';
import { Checkbox, Typography, Box, FormControlLabel, Divider } from '@mui/material';
import SparklesIcon from '@mui/icons-material/AutoAwesome';
import WavesIcon from '@mui/icons-material/Waves';
import UtensilsIcon from '@mui/icons-material/Restaurant';
import HeadphonesIcon from '@mui/icons-material/Headset';

import {
  GENERAL_AMENITIES,
  RECREATIONAL_AMENITIES,
  DINING_AMENITIES,
  SERVICE_AMENITIES,
} from '../types/property';

export function AmenitiesSection({ formData, onChange }) {
  const amenities = formData.amenities || {
    general: [],
    recreational: [],
    dining: [],
    services: [],
  };

  const toggleAmenity = (category, amenity) => {
    const currentAmenities = amenities[category] || [];
    const updatedAmenities = currentAmenities.includes(amenity)
      ? currentAmenities.filter((a) => a !== amenity)
      : [...currentAmenities, amenity];

    onChange('amenities', {
      ...amenities,
      [category]: updatedAmenities,
    });
  };

  const AmenityCategory = ({ title, Icon, items, category }) => (
    <Box sx={{ mb: 4 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
        <Icon sx={{ color: 'primary.main' }} />
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          {title}
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' },
          gap: 2,
        }}
      >
        {items.map((item) => (
          <FormControlLabel
            key={item}
            control={
              <Checkbox
                checked={amenities[category]?.includes(item)}
                onChange={() => toggleAmenity(category, item)}
                id={`${category}-${item}`}
              />
            }
            label={
              <Typography
                component="label"
                htmlFor={`${category}-${item}`}
                sx={{ cursor: 'pointer', fontSize: '0.875rem' }}
              >
                {item}
              </Typography>
            }
          />
        ))}
      </Box>
      {category !== 'services' && <Divider sx={{ mt: 3 }} />}
    </Box>
  );

  return (
    <Box sx={{ py: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
        <SparklesIcon sx={{ color: 'primary.main' }} />
        <Typography variant="h5" sx={{ fontWeight: 700 }}>
          Amenities & Facilities
        </Typography>
      </Box>

      <AmenityCategory
        title="General Amenities"
        Icon={SparklesIcon}
        items={GENERAL_AMENITIES}
        category="general"
      />

      <AmenityCategory
        title="Recreational Facilities"
        Icon={WavesIcon}
        items={RECREATIONAL_AMENITIES}
        category="recreational"
      />

      <AmenityCategory
        title="Dining & Food"
        Icon={UtensilsIcon}
        items={DINING_AMENITIES}
        category="dining"
      />

      <AmenityCategory
        title="Services"
        Icon={HeadphonesIcon}
        items={SERVICE_AMENITIES}
        category="services"
      />
    </Box>
  );
}
